<div class="gradient-box bg-gray-50">
  <div class="img" [innerHTML]="content"></div>
</div>
